import * as React from 'react';
import { useState } from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import { CustomFormControl } from 'components/Form/FormControl';

import styles from './styles.module.scss';

type InputProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSetCustomRejection: (reason: string) => void;
};

export const CustomRejectionDialog = ({
  open = false,
  setOpen,
  onSetCustomRejection,
}: InputProps) => {
  const [value, setValue] = useState<string>('');
  const [error, setError] = useState<string>('');

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const v = event.target.value.toString();
    setValue(v);
    setError('');
  };

  const handleSetCustomRejection = () => {
    if (!value) {
      setError('This field cannot be empty');
    } else {
      onSetCustomRejection(value);
    }
  };

  return (
    <CustomDialog open={open} setOpen={setOpen} title="Custom Rejection">
      <div className={styles.root}>
        <CustomFormControl
          error={error}
          label="Rejection Reason"
          required={true}
          inputProps={{
            value,
            onChange: handleChange,
          }}
        />
        <div className={styles.actions}>
          <ButtonWithArrowIcon
            onClick={handleSetCustomRejection}
            disabled={!value}
          >
            Next
          </ButtonWithArrowIcon>
        </div>
      </div>
    </CustomDialog>
  );
};
